import React, { useEffect } from "react";
import { useState } from "react";
import {
  Button,
  FormFieldSet,
  Modal,
  NewTab,
  PageTab,
  PageTitle,
  ToggleButton,
  useFormHandler,
  showToast,
} from "../../../../../../components";
import ByRole from "./AutomationTabs/ByRole";
import ByUser from "./AutomationTabs/ByUser";
import { v4 as uuid } from "uuid";
import { getAllIntegrations, getBdmSettingsApi, updateResumeMiningSettingsApi } from "../../../../../../redux/slices/setting/settingApi";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { totalCountStart } from "../../../../../../redux/slices/totalCount/totalCountSlice";

const ResumeMiningDetails = () => {
  const [isEnabled, setIsEnabled] = useState(false);
  const [timeZone, setTimeZone] = useState("");
  const [timeFormat, setTimeFormat] = useState("");
  const [validationRules, setValidationRules] = useState();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { value } = useSelector((state) => state.totalCount);

  const [checkMultiSelect, setCheckMultiSelect] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [options, setOptions] = useState([]);
  const [integrations, setIntegrations] = useState({});
  const [buttonLoading, setButtonLoading] = useState(true);


  // const initialFormData = {
  //   id: uuid(),
  //   resume: ""

  // };

  const initialFormData = {
    id: uuid(),
    timeZone: 4,
    timeFormat: 2,
    // frequency: 4,
    perResumeMiningLimit: "",
    byRole: [],
    byUser: [],
    isEnabled: false,
    resumeMiningFrom: "",
    stopMiningAfterDays: "",
    resumeMiningJob: "",
    resumeMiningLimitPerJob: "",
  };


  const JOB_BOARD_CONFIG = [
    {
      type: 1,
      title: "Monster",
    },
    {
      type: 2,
      title: "Career Builder",
    },
    {
      type: 3,
      title: "Shine",
    },
    {
      type: 4,
      title: "Naukri",
    },
    {
      type: 5,
      title: "LinkedIn",
    },
    {
      type: 6,
      title: "ZipRecruiter",
    },
    {
      type: 7,
      title: "Jora",
    },
  ];



  const fetchTotalIntegrationsCount = () => {
    dispatch(
      totalCountStart({
        collection: "integrations",
        coll: "Integration",
        tname: "allIntegrations",
        app: "ats",
        filters: { status: { type: "NONE", value: 1 } },
      })
    );
  };

  const prepareIntegrationState = (integrationData) => {
    const statusMap = {};

    for (const item of integrationData) {
      const key = `${item.category}-${item.type}`;
      statusMap[key] = item;
    }
    setIntegrations(statusMap);
  };
  // console.log(integrations)

  const fetchAllINtegrations = async () => {
    const limit = value?.allIntegrations?.data;
    if (limit || limit > 0) {
      const params = {
        coll: "Integration",
        fil: JSON.stringify({ status: { type: "NONE", value: 1 } }),
        lim: limit,
        ret: "uiid category type status addedBy addedOn updatedAt",
      };
      try {
        const allIntegrations = await getAllIntegrations(params);
        // console.log(allIntegrations)
        if (allIntegrations.success) {
          const integrationData = allIntegrations?.data?.data.filter((i) => i.category === 3); //category 3 refers to jobboards
          // console.log("integration data====", integrationData)
          prepareIntegrationState(integrationData);
          setButtonLoading(false);
        } else {
          showToast("Failed to fetch Integrations", "error");
          setButtonLoading(false);
        }
      } catch (error) {
        showToast("Failed to fetch Integrations", "error");
        setButtonLoading(false);
      }
    } else {
      setButtonLoading(false);
    }
  };

  useEffect(() => {
    fetchAllINtegrations();
  }, [value?.allIntegrations?.data]);

  useEffect(() => {
    // checkIntegrationStatus();
    fetchTotalIntegrationsCount();
  }, []);

  const integrationArray = Object.values(integrations);
  const resumeMiningOptions = integrationArray
    .map(integration =>
      JOB_BOARD_CONFIG.find(
        board => board.type === integration.type
      )
    )
    .filter(Boolean)
    .map(board => ({
      label: board.title, // title
      value: board.type, // type
    }));

  // console.log("resume", resumeMiningOptions)



  // const { formData, handleChange } = useFormHandler(initialFormData, {});
  const {
    formData,
    errors,
    handleChange,
    validateAllFields,
    setFormData,
    resetForm,
  } = useFormHandler(initialFormData, validationRules);
  // console.log("----------=======", formData)
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        //const response = await getBdmSettingsApi({ coll: "Setting", lim: 1, ref: "Role", incl: ["resumeMiningSettings.access.byUserIds.uiid firstName"] });
        const response = await getBdmSettingsApi({ coll: "Setting", lim: 1 });
        const settings = response?.data?.data?.[0];
        if (settings?.resumeMiningSettings) {
          const { resumeMiningSettings } = settings;
          setFormData((prev) => ({
            ...prev,
            timeZone: resumeMiningSettings.resumeMiningFrequency?.timeZone || 4,
            timeFormat: resumeMiningSettings.resumeMiningFrequency?.timeFormat || 2,
            // frequency: resumeMiningSettings.resumeMiningFrequency?.frequency || 4,
            perResumeMiningLimit: resumeMiningSettings.resumeMiningLimit?.toString() || "",
          //byUser: resumeMiningSettings?.access?.byUserIds?.map(item => item?.uiid) || [],
            byUser: resumeMiningSettings?.access?.byUserIds || [],
            byRole: resumeMiningSettings?.access?.byRoleIds || [],
            isEnabled: resumeMiningSettings.resumeHarvesting?.isEnabled || false,
            resumeMiningFrom: resumeMiningSettings.resumeHarvesting?.sourceId || "",
            stopMiningAfterDays: resumeMiningSettings.resumeHarvesting?.stopAfterDays?.toString() || "",
            resumeMiningJob: resumeMiningSettings.resumeHarvesting?.jobId || "",
            resumeMiningLimitPerJob: resumeMiningSettings.resumeHarvesting?.limitPerJob?.toString() || "",
          }));



          // If source is present, enable the toggle
          if (resumeMiningSettings.resumeHarvesting?.source) {
            setFormData(prev => ({ ...prev, isEnabled: true }));
            setIsEnabled(true);
          }
        }
      } catch (error) {
        console.error("Error fetching settings:", error);
      }
    };

    fetchSettings();
  }, []);

  const sendpayload = [
    {
      type: "SET",
      value: {
        _skipFlatten: [
          "resumeMiningSettings.access.byRoleIds",
          "resumeMiningSettings.access.byUserIds",
        ],
        resumeMiningSettings: {
          resumeMiningFrequency: {
            timeZone: 4, // Hardcoded UTC
            timeFormat: 2, // Hardcoded 24h
            // frequency: 4, // Hardcoded Max 4
          },
          resumeMiningLimit: Number(formData.perResumeMiningLimit),
          access: {
            byRoleIds: formData.byRole,
            byUserIds: formData.byUser,
          },
          resumeHarvesting: {
            isEnabled: formData.isEnabled,
            ...(formData.isEnabled && {
              sourceId: formData.resumeMiningFrom,
              stopAfterDays: Number(formData.stopMiningAfterDays),
              jobId: formData.resumeMiningJob.uiid,
              limitPerJob: Number(formData.resumeMiningLimitPerJob),
            }),
          },
        },
      },
    },
  ];

  const handleSubmit = async () => {
    const isValid = validateAllFields();
    if (!isValid) return;
    // console.log(formData)
    const payload = buildResumeMiningPayload(formData);



    try {
      const getRes = await getBdmSettingsApi({ coll: "Setting", lim: 1 });

      const uiid = getRes?.data?.data?.[0]?.uiid;
      // console.log(getRes)

      if (uiid) {
        const response = await updateResumeMiningSettingsApi({
          uiid: uiid,
          payload: sendpayload,
        });
        if (response.success) {
          showToast("Details updated successfully!", "success");
        } else {
          showToast("Failed to update details!", "error");
        }
      } else {
        showToast("Settings UIID not found!", "error");
      }
    } catch (error) {
      console.error("Error updating settings:", error);
    }
  };
  useEffect(() => {
    const rules = {
      perResumeMiningLimit: {
        type: "text",
        required: true,
      },

      resumeMiningFrom: {
        type: "select",
        required: formData?.isEnabled,
      },
      stopMiningAfterDays: {
        type: "text",
        required: formData?.isEnabled,
      },
      resumeMiningJob: {
        type: "select",
        required: formData?.isEnabled,
      },
      resumeMiningLimitPerJob: {
        type: "text",
        required: formData?.isEnabled,
      },

    };

    setValidationRules(rules);
  }, [formData?.isEnabled]);

  const buildResumeMiningPayload = (data) => {
    return {
      resumeMiningFrequency: {
        timeZone: 4,
        timeFormat: 2,
        // frequency: 4,
      },

      resumeMiningLimit: Number(data.perResumeMiningLimit),

      access: {
        byRoleIds: data.byRole,
        byUserIds: data.byUser,
      },

      resumeHarvesting: {
        isEnabled: data.isEnabled,
        ...(data.isEnabled && {
          sourceId: data.resumeMiningFrom,
          stopAfterDays: Number(data.stopMiningAfterDays),
          jobId: data.resumeMiningJob.uiid,
          limitPerJob: Number(data.resumeMiningLimitPerJob),
        }),
      },

    };
  };
  // console.log("payload",buildResumeMiningPayload)



  // const handleTimeZoneChange = (value) => {
  //   setTimeZone(value);
  // };

  const ResumeMiningTabs = [
    {
      title: "By Role",
      page: (
        <ByRole
          value={formData.byRole}  // selected roles only
          onChange={(roles) => handleChange("byRole", roles)}
        />
      ),
      type: "main",
      id: "",
    },
    {
      title: "By User",
      page: (
        <ByUser
          value={formData.byUser}  // selected users only
          onChange={(users) => handleChange("byUser", users)}
        />
      ),
      type: "main",
      id: "",
    },
  ];


  // Reusable field wrapper ensures consistent width
  const Field = (props) => (
    <div className="w-full md:w-[280px]">
      <FormFieldSet {...props} />
    </div>
  );

  // const handleToggle = (checked) => {
  //   setIsEnabled | checked;
  // };

  return (
    <>
      <div>
        <Modal width="max-w-3xl" titleColor="primary" />

        <div className="flex flex-col gap-6 mt-4">

          <Card
            title="Resume Mining Frequency"
            desc="Configuration: Max 4 times/day, UTC Time Zone, 24h Format."
          >
            {/* Inputs hidden as per requirement to hardcode values */}
          </Card>

          <Card title="Resume Mining Limits" className="shadow-lg">
            <Field
              type="text"
              title="Per Resume Mining Limit"
              placeholder="50"
              value={formData.perResumeMiningLimit}
              onChange={(val) => handleChange("perResumeMiningLimit", val)}
              error={errors.perResumeMiningLimit}
              shadow
            />

          </Card>
          <Card title="User Access For Scheduled Resume Mining">
            <NewTab
              tabs={ResumeMiningTabs}
              color="gray"
              variant="text"
              activeVariant="text"
            />
          </Card>

          <Card className="p-5">
            <div className="flex items-center gap-4">
              <FormFieldSet
                type="toggle"
                size="sm"
                label="User Access For Scheduled Resume Mining"
                noTitle
                isChecked={formData.isEnabled}
                onChange={() =>
                  handleChange("isEnabled", !formData.isEnabled)
                }
              />

            </div>

            {!formData.isEnabled ? (
              <ul className="list-disc list-inside text-sm text-gray-600 space-y-1 mt-3">
                <p>
                  Allows harvesting of resumes automatically once the job is
                  created. You can configure the number of days the harvester
                  should fetch resumes and the number of resumes to be harvested
                  per
                  <br /> jobBoard.
                </p>
                <span className="font-semibold">Enable Resume Harvesting.</span>
                <p>
                  Currently your automated resume harvesting setting is
                  disabled.
                </p>
                <p>
                  To enable the feature, please use the toggle switch above.
                </p>
              </ul>
            ) : (
              <div className="mt-4 space-y-3">
                <p className="text-sm mt-2">
                  Allows harvesting of resumes automatically once the job is
                  created. You can configure the number of days the harvester
                  should fetch resumes and the number of resumes to be harvested
                  per jobBoard.
                </p>
                <div className="flex gap-5 items-center">
                  <Field
                    type="select"
                    title="Resume Mining From"
                    placeholder="Select"
                    value={formData.resumeMiningFrom}
                    onChange={(val) => handleChange("resumeMiningFrom", val)}
                    options={resumeMiningOptions}
                    error={errors.resumeMiningFrom}
                    shadow
                  />


                  <Field
                    type="text"
                    title=" "
                    placeholder="Stop Resume Mining After"
                    value={formData.stopMiningAfterDays}
                    onChange={(val) => handleChange("stopMiningAfterDays", val)}
                    error={errors.stopMiningAfterDays}
                    shadow
                  />
                  <span className="mt-4">Day(s) after job creation</span>
                </div>

                <div className="flex gap-5 items-center">
                  <Field
                    type="companiesSearch"
                    title="Resume Mining Job"
                    placeholder="Select Job"
                    value={formData.resumeMiningJob}
                    onChange={(val) => handleChange("resumeMiningJob", val)}
                    error={errors.resumeMiningJob}
                    shadow
                    showSearch
                  />

                  <Field
                    type="text"
                    title=" "
                    placeholder="Limit Resume Mining To"
                    value={formData.resumeMiningLimitPerJob}
                    onChange={(val) =>
                      handleChange("resumeMiningLimitPerJob", val)
                    }
                    error={errors.resumeMiningLimitPerJob}
                    shadow
                  />
                  <span className="mt-4">Profile(s) for each job</span>
                </div>
              </div>
            )}

          </Card>
        </div>
      </div>
      <div className="flex justify-end gap-3 mt-6">
        <Button title="Cancel" variant="outlined" />
        <Button title="Save" onClick={handleSubmit} />
      </div>
    </>
  );
};

const Card = ({ title, desc, children }) => (
  <div className="p-4 rounded-lg border border-gray-200 shadow-md space-y-3">
    {title && <PageTitle title={title} size="sm" />}
    {desc && <p className="text-sm text-gray-600">{desc}</p>}
    {children}
  </div>
);

export default ResumeMiningDetails;
